import { api } from '../api';
import type { CallGrant, CallStatus, Id } from '../types';

export interface PersistentCall {
  id: Id;
  conversationId: Id;
  status: Exclude<CallStatus, 'idle'>;
  generation: number;
  settlement: 'pending' | 'settled' | 'reconciliation_required';
}

export function reserveVoiceCall(conversationId: string): Promise<PersistentCall> {
  return api.request('/voice/calls', {
    method: 'POST',
    body: JSON.stringify({ conversationId })
  });
}

export function connectVoiceCall(callId: string, input: {
  operationId: string;
  sdpOffer: string;
  estimatedMicrounits?: number;
  voice?: string;
}): Promise<CallGrant> {
  return api.request(`/voice/calls/${encodeURIComponent(callId)}/connect`, {
    method: 'POST',
    body: JSON.stringify(input)
  });
}

export function heartbeatVoiceCall(callId: string, generation: number): Promise<PersistentCall> {
  return api.request(`/voice/calls/${encodeURIComponent(callId)}/heartbeat`, {
    method: 'POST',
    body: JSON.stringify({ generation })
  });
}

export function endVoiceCall(callId: string, generation: number, actualMicrounits?: number): Promise<PersistentCall> {
  return api.request(`/voice/calls/${encodeURIComponent(callId)}/end`, {
    method: 'POST',
    body: JSON.stringify({ generation, ...(actualMicrounits === undefined ? {} : { actualMicrounits }) })
  });
}
